//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { textsDefaul } from '@/js/constants';
import TableLogDetail from '@/components/TableLogDetail';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
export default {
  name: 'ListTableLogs',
  components: {
    TableLogDetail: TableLogDetail
  },
  props: {
    objectId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      logsList: [],
      loadListStaus: textsDefaul.LOADING
    };
  },
  created: function created() {
    this.listLogs();
  },
  methods: {
    listLogs: function listLogs() {
      var _this = this;
      var params = {
        objectId: this.objectId
      };
      TablesService.logQuery(params).then(function (response) {
        console.log(response);
        if (response.code === 200 && response.data && response.data.length) {
          _this.logsList = response.data;
          if (!_this.loadListStaus.length) _this.loadListStaus = textsDefaul.NOT_FOUND;
        } else {
          _this.loadListStaus = textsDefaul.NOT_HISTORY_LOGS;
        }
      });
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: 'Applicant',
        value: 'created_by'
      }, {
        text: 'Log Type',
        value: 'type'
      }, {
        text: 'Description',
        value: 'description'
      }, {
        text: 'Created',
        value: 'created_time'
      }, {
        text: 'Response',
        value: 'response'
      }];
    }
  }
};